import LinesDataView from "./LinesDataView";
import SydFilterProvider from "src/components/Common/UI/SydFilter/SydFilterContext";
import SydFilterView from "src/components/Common/UI/SydFilter/SydFilterView";
import SearchPhoneLines from "./SearchDataLines";

const defaultFilterData: IDataLineSearchForm = {
  descline: "",
  hcNmsNum: "",
  providerID: "",
  sapCode: "",
  phoneNumber: "",
  pendingStatusID: "",
  speedID: "",
  lineTypeID: "",
  deleted: "",
  removalDateFrom: "",
  removalDateTo: "",
  comments: ""
}

const Lines = () => {
  
  return (
    <SydFilterProvider
      defaultFilterData={defaultFilterData}
    >
      <SydFilterView  title="Αναζήτηση γραμμής Data">
        <SearchPhoneLines />
      </SydFilterView>

      <LinesDataView />
    </SydFilterProvider>
  )

}
export default Lines;

